import { inspectionReportService } from '../../helpers/services/inspectionReport.service';
import { sharedHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const INSPECTION_REPORT_MODULE = 'inspectionReport';

// define action 
export const GET_ALL_INSPECTION_REPORTS = 'getAllInspectionReports';
export const GET_INSPECTION_REPORT_REQUEST = 'getInspectionReport';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_INSPECTION_REPORTS_REQUEST = "getAllInspectionReports";
const GET_INSPECTION_REPORT = "getInspectionReport";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_INSPECTION_REPORTS]({ commit }, { filter }) {
        inspectionReportService
            .getAllInspectionReports(filter)
            .then(
                (result) => {
                    commit(GET_ALL_INSPECTION_REPORTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_INSPECTION_REPORT]({ commit }, { id }) {
       await inspectionReportService
            .getInspectionReport(id)
            .then(
                (result) => {
                    commit(GET_INSPECTION_REPORT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Inspection-report-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_INSPECTION_REPORTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                mileage: o.mileage,
                fuel: o.fuel,
                faultDescription: o.fault_description,
                leftTopTyreWidth: o.left_top_tyre_width,
                leftTopTyreAspectRatio: o.left_top_tyre_aspect_ratio,
                leftTopTyreDiameterWheel: o.left_top_tyre_diameter_wheel,
                rightTopTyreWidth: o.right_top_tyre_width,
                rightTopTyreAspectRatio: o.right_top_tyre_aspect_ratio,
                rightTopTyreDiameterWheel: o.right_top_tyre_diameter_wheel,
                leftBottomTyreWidth: o.left_bottom_tyre_width,
                leftBottomTyreAspectRatio: o.left_bottom_tyre_aspect_ratio,
                leftBottomTyreDiameterWheel: o.left_bottom_tyre_diameter_wheel,
                rightBottomTyreWidth: o.right_bottom_tyre_width,
                rightBottomTyreAspectRatio: o.right_bottom_tyre_aspect_ratio,
                rightBottomTyreDiameterWheel: o.right_bottom_tyre_diameter_wheel,
                isActive: o.is_active,
                newReport: o.new_report,
                leftTopTyreBrand: o.left_top_tyre_brand,
                rightTopTyreBrand: o.right_top_tyre_brand,
                leftBottomTyreBrand: o.left_bottom_tyre_brand,
                rightBottomTyreBrand: o.right_bottom_tyre_brand,
                apperanceDamageMedias: o.apperance_damage_medias,
                itemLeftMedias: o.item_left_medias,
                warningLightMedias: o.warning_light_medias,
                brakeFluids: o.brake_fluids,
                brokenDisplays: o.broken_displays,
                carKeyPresents: o.car_key_presents,
                ecoUpgradeds: o.eco_upgradeds,
                fuelFilterAuthoriseds: o.fuel_filter_authoriseds,
                fuelFilterConditions: o.fuel_filter_conditions,
                lockingWheelNuts: o.locking_wheel_nuts,
                serviceBookPresents: o.service_book_presents,
                wheelTorque: o.wheel_torque,
            }
        })
    },
    [GET_INSPECTION_REPORT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            mileage: o.mileage,
            fuel: o.fuel,
            faultDescription: o.fault_description,
            leftTopTyreWidth: o.left_top_tyre_width,
            leftTopTyreAspectRatio: o.left_top_tyre_aspect_ratio,
            leftTopTyreDiameterWheel: o.left_top_tyre_diameter_wheel,
            rightTopTyreWidth: o.right_top_tyre_width,
            rightTopTyreAspectRatio: o.right_top_tyre_aspect_ratio,
            rightTopTyreDiameterWheel: o.right_top_tyre_diameter_wheel,
            leftBottomTyreWidth: o.left_bottom_tyre_width,
            leftBottomTyreAspectRatio: o.left_bottom_tyre_aspect_ratio,
            leftBottomTyreDiameterWheel: o.left_bottom_tyre_diameter_wheel,
            rightBottomTyreWidth: o.right_bottom_tyre_width,
            rightBottomTyreAspectRatio: o.right_bottom_tyre_aspect_ratio,
            rightBottomTyreDiameterWheel: o.right_bottom_tyre_diameter_wheel,
            isActive: o.is_active,
            newReport: o.new_report,
            leftTopTyreBrand: o.left_top_tyre_brand,
            rightTopTyreBrand: o.right_top_tyre_brand,
            leftBottomTyreBrand: o.left_bottom_tyre_brand,
            rightBottomTyreBrand: o.right_bottom_tyre_brand,
            apperanceDamageMedias: o.apperance_damage_medias,
            itemLeftMedias: o.item_left_medias,
            warningLightMedias: o.warning_light_medias,
            brakeFluids: o.brake_fluids,
            brokenDisplays: o.broken_displays,
            carKeyPresents: o.car_key_presents,
            ecoUpgradeds: o.eco_upgradeds,
            fuelFilterAuthoriseds: o.fuel_filter_authoriseds,
            fuelFilterConditions: o.fuel_filter_conditions,
            lockingWheelNuts: o.locking_wheel_nuts,
            serviceBookPresents: o.service_book_presents,
            wheelTorque: o.wheel_torque,
        }
    }
}


